module.exports = __webpack_public_path__ + "img/22051901.245de501.jpg";